
<template>
    <div v-if="variant.tiers">
        <p>Lets take this product ({{ variant.sku }}) as an example:</p>

        <table class="table table-striped table-condensed">
            <thead>
                <tr>
                    <th>Qty</th>
                    <th>Unit cost</th>
                    <th>Total</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="qty in breaks" :key="qty">
                    <td>{{ qty }}</td>
                    <td><product-price :price="unitCost(qty).unit" :tax="unitCost(qty).tax" ></product-price></td>
                    <td><product-price :price="unitCost(qty).unit * qty" :tax="unitCost(qty).tax * qty" ></product-price></td>
                </tr>
            </tbody>
        </table>

          <!-- <p>10 will cost £1.37 x 0.1 = £0.14<br>
          100 will cost £1.37 x 1 = £1.37<br>
          340 will cost £1.37 x 3.4 = £4.66<br>
          500 will cost £0.86 x 5 = £4.30<br>
          2,500 will cost £0.77 x 25 = £19.25</p> -->
    </div>
</template>

<script>
    import Product from '../../Services/Product.js';
    import Variant from '../../Services/Variant.js';
    import ProductPrice from './ProductPrice';

    export default {
        components: {
            ProductPrice,
        },
        data() {
            return {
                products: Product,
                breaks: [10, 100, 250, 500, 2500]
            };
        },
        methods: {
            unitCost(qty) {
                const tier = Variant.currentTier(this.variant.tiers, qty);

                let price = {
                    unit: this.variant.price / this.variant.unit_qty,
                    tax: this.variant.tax / this.variant.unit_qty,
                };

                if (tier) {
                    price = {
                        unit: tier.price / this.variant.unit_qty,
                        tax: tier.tax / this.variant.unit_qty,
                    };
                }

                return price;
            },
            total() {
                return 0;
            }
        },
        computed: {
            variant() {
                return this.products.variant;
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Product/VariantPricingHelp.vue